export default {
	'light': () => import(
		/* webpackChunkName: "./themes/light" */
		'./themes/light.js'
	),
	'light-future': () => import(
		/* webpackChunkName: "./themes/light-future" */
		'./themes/light-future.js'
	),
	'dark': () => import(
		/* webpackChunkName: "./themes/dark" */
		'./themes/dark.js'
	),
	'dark-future': () => import(
		/* webpackChunkName: "./themes/dark-future" */
		'./themes/dark-future.js'
	),
	'legacy-light': () => import(
		/* webpackChunkName: "./themes/legacy-light" */
		'./themes/legacy-light.js'
	),
	'legacy-dark': () => import(
		/* webpackChunkName: "./themes/legacy-dark" */
		'./themes/legacy-dark.js'
	),
	'spacing': () => import(
		/* webpackChunkName: "./themes/spacing" */
		'./themes/spacing.js'
	),
	'shape': () => import(
		/* webpackChunkName: "./themes/shape" */
		'./themes/shape.js'
	),
	'typography-adg3': () => import(
		/* webpackChunkName: "./themes/typography-adg3" */
		'./themes/typography-adg3.js'
	),
	'typography-modernized': () => import(
		/* webpackChunkName: "./themes/typography-modernized" */
		'./themes/typography-modernized.js'
	),
	'typography-refreshed': () => import(
		/* webpackChunkName: "./themes/typography-refreshed" */
		'./themes/typography-refreshed.js'
	),
	'original': () => Promise.resolve(''),
};